import React, {Fragment} from 'react'
import { graphql, StaticQuery } from 'gatsby'


class Hero extends React.Component{
    constructor(props){
        super(props)
    }

    render(){
    const {headerBackBlue} = this.props.query;
        return(
            <Fragment>
                <section class="static-banner static-page-banner" style={{background: `url(${headerBackBlue.publicURL})`}}>
                    <div class="custom-container">
                        <div class="content-img">
                            <div class="col-lg-12 col-sm-12 col-md-12 col-xs-12">
                                <div class="row">
                                    <h3>Kontakta oss</h3>	
                                </div>
                            </div>
                        </div>
                        </div>
                    </section>
            </Fragment>
        )
    }
}

export default (props) => (
    <StaticQuery
        query= { graphql`
                query {
                    headerBackBlue: file(relativePath: {regex: "/plain-small-background/"}) {
                        publicURL
                    }
                }`
            }
        render={(data)  => (
           <Hero query={data} {...props}/>
        )}
    />
)